import { styled } from 'styled-components';

import { cssBreakpoints, spacing } from '#/theme/theme';

export const EmbedSearchWidgetLayoutSearchFormEl = styled.form`
  padding: ${spacing['16']};
  display: flex;
  gap: 12px;

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    flex-direction: column;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const EmbedSearchWidgetLayoutSearchQueryInputMaybeButtonHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  flex: 8;
`;

export const EmbedSearchWidgetLayoutSearchLocationHolder = styled.footer`
  flex-shrink: 0;

  @media all and (max-height: ${cssBreakpoints.smDown}) {
    width: 100%;
  }

  @media all and (max-height: ${cssBreakpoints.smUp}) {
    width: 226px;
  }
`;

export const EmbedSearchWidgetLayoutSearchMobileButtonHolder = styled.div`
  flex-shrink: 0;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    display: none;
  }
`;

export const EmbedSearchWidgetLayoutSearchDesktopButtonHolder = styled.div`
  flex: 1;
  min-width: 106px;
  max-width: 162px;

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    display: none;
  }
`;
